export interface AudienceRetentionRow {
  elapsedVideoTimeRatio: number;
  audienceWatchRatio: number;
}

export interface AudienceRetentionChartPoint {
  timeSeconds: number;
  retentionPct: number;
  positionPct: number;
}

export interface PreparedAudienceRetentionChartData {
  hasRetentionData: boolean;
  durationSeconds: number;
  chartPoints: AudienceRetentionChartPoint[];
}

export function prepareAudienceRetentionChartData(input: {
  audienceRetention: AudienceRetentionRow[];
  durationSeconds: number;
}): PreparedAudienceRetentionChartData {
  const { audienceRetention, durationSeconds } = input;

  if (
    !audienceRetention?.length ||
    durationSeconds == null ||
    durationSeconds <= 0
  ) {
    return {
      hasRetentionData: false,
      durationSeconds: durationSeconds ?? 0,
      chartPoints: [],
    };
  }

  const chartPoints = [...audienceRetention]
    .map((row) => ({
      timeSeconds: row.elapsedVideoTimeRatio * durationSeconds,
      retentionPct: row.audienceWatchRatio * 100,
      positionPct: row.elapsedVideoTimeRatio * 100,
    }))
    .sort((a, b) => a.timeSeconds - b.timeSeconds);

  return {
    hasRetentionData: chartPoints.length > 0,
    durationSeconds,
    chartPoints,
  };
}
